import React from "react";
import SampleTestCaseTable from "../../Practice/Components/SampleTestCaseTable.jsx";

const CompilerQuestionCard = ({ question, loading, isCompleted }) => {
  const onCopyHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case "EASY":
        return "bg-green-200 text-gray-800";
      case "MEDIUM":
        return "bg-yellow-100 text-gray-800";
      case "HARD":
        return "bg-red-200 text-gray-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const difficulty = question?.difficulty
    ? question.difficulty.charAt(0).toUpperCase() + question.difficulty.slice(1).toLowerCase()
    : null;

  if (loading) {
    return (
      <div className="shadow-md bg-white p-8 rounded-md items-center">
        Loading
      </div>
    );
  }

  return (
    <div
      className="relative font-poppins h-full w-full max-w-none overflow-y-auto"
      style={{
        msOverflowStyle: "none", // IE and Edge
        scrollbarWidth: "none",  // Firefox
      }}
      onCopy={onCopyHandler}
    >
      {/* Chrome / Safari scrollbar hide */}
      <style>
        {`
          div::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>

      <div className="flex justify-between items-start mb-4">
        <h1 className="text-2xl font-bold text-gray-900">{question?.title}</h1>
        
        <div className="flex items-center gap-2">
          {/* Difficulty tag - appears left of completed tag when completed, or at right end when not completed */}
          {difficulty && (
            <div
              className={`px-3 py-1 text-sm font-medium rounded-md ${getDifficultyColor(question.difficulty)}`}
            >
              {difficulty}
            </div>
          )}
          
          {/* Completed tag */}
          {isCompleted && (
            <div className="px-3 py-1 text-sm font-medium rounded-md bg-green-100 text-green-800">
              Completed
            </div>
          )}
        </div>
      </div>

      {/* Question Text */}
      <div
        className="mb-6 text-gray-700 leading-relaxed
                  prose prose-gray max-w-none
                  prose-p:mb-3 prose-li:mb-1
                  prose-strong:text-gray-900 prose-strong:font-semibold"
        dangerouslySetInnerHTML={{
          __html: question?.text,
        }}
      />

      <h2 className="text-lg font-semibold text-gray-900 mb-3">Sample Test Case:</h2>
      <div className="w-full">
        <SampleTestCaseTable question={question} />
      </div>

      {question?.hints?.length > 0 && (
        <div className="mt-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Hints:
          </h3>
          <ul className="list-decimal list-inside space-y-1 text-gray-700">
            {question.hints.map(
              (hint, index) =>
                hint && (
                  <li key={index} className="leading-relaxed">
                    {hint}
                  </li>
                )
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CompilerQuestionCard;
